import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticatedLayoutComponent } from './core/components/authenticated-layout/authenticated-layout.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { AuthComponent } from './auth/base/components/auth/auth.component';
import { AppInitService } from './core/services/app-init.service';
import { HeaderComponent } from './core/components/header/header.component';
import { SidenavComponent } from './core/components/sidenav/sidenav.component';
import { PopupComponent } from './core/components/popup/popup.component';
import { SubpageHeaderModule } from './shared/subpage-header/subpage-header.module';
import { MenuComponent } from './core/components/menu/menu.component';
import { SpinnerModule } from './shared/spinner/spinner.module';
import { ApiClientsModule } from './api-clients/api-clients.module';
import { RefreshPageComponent } from './pages/refresh-page/refresh-page.component';
import { MaintenanceModePageComponent } from './pages/maintenance-mode-page/maintenance-mode-page.component';
import { AccessDeniedPageComponent } from './pages/access-denied-page/access-denied-page.component';
import { RolesModule } from './roles/roles.module';
import { ErrorWarningModalComponent } from './error-warnings/components/error-warning-modal/error-warning-modal.component';
import { SecondaryPopupComponent } from './shared/secondary-popup/components/secondary-popup/secondary-popup.component';

// function will run on app init and check if token in local storage exist and set val to isAuthenticated
const initApp = (appInitService: AppInitService) => () => appInitService.init();

export function translateHttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, 'assets/i18n/');
}

@NgModule({
  declarations: [
    AppComponent,
    AuthenticatedLayoutComponent,
    HomePageComponent,
    AuthComponent,
    HeaderComponent,
    SidenavComponent,
    PopupComponent,
    MenuComponent,
    RefreshPageComponent,
    MaintenanceModePageComponent,
    AccessDeniedPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ApiClientsModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateHttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SubpageHeaderModule,
    SpinnerModule,
    RolesModule,
    ErrorWarningModalComponent,
    SecondaryPopupComponent
  ],
  providers: [provideAppInitializer(() => initApp(inject(AppInitService))())],
  bootstrap: [AppComponent]
})
export class AppModule {}
